import { EvaluationType } from 'types/evaluation';
import { useStudentImpactEvaluations, useManagerImpactEvaluations, useImpactEvaluationsQuery } from 'pctContexts/ImpactEvaluationsContext';

export const useHasImpactEvaluations = (userId: number, evaluationType: EvaluationType) => {
    return useImpactEvaluationsQuery(userId, evaluationType);
};

export const useHasStudentImpactEvaluations = (userId: number) => {
    return useStudentImpactEvaluations(userId);
};

export const useHasManagerImpactEvaluations = (userId: number) => {
    return useManagerImpactEvaluations(userId);
};
